import { useEffect, useState } from "react";

const useScrollToTopButton1Logic = () => {
  const [scrollBahevior, setScrollBahevior] = useState(false);
  const scrolledDownValue = 100;

  useEffect(() => {
    const onScroll = () => {
      setScrollBahevior(window.scrollY > scrolledDownValue);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [scrollBahevior]);

  return { scrollBahevior, setScrollBahevior, scrolledDownValue };
};

export default useScrollToTopButton1Logic;
